export const MAX_JOB_COUNT = 1000;
export const MAX_WORK_ORDER_COUNT = 1000;
